// Exact hostnames only. Use the same name for multiple domains to combine their series.
export const PAGE_VIEW_PROJECTS: Record<string, string> = {
  'app.boxpressd.com': 'Boxpressd Social',
  'shop.boxpressd.com': 'Boxpressd Shop',
  'sites.boxpressd.com': 'Boxpressd Sites',
  'cigarsnearme.com': 'Cigars Near Me',
};

// Optional deployment annotations, in UTC. Add entries from your deployment history.
export const PAGE_VIEW_DEPLOYMENTS: {
  timestamp: string;
  hostname: string;
  label: string;
}[] = [];

// Local development traffic is omitted from all dashboard metrics and tables.
export const PAGE_VIEW_EXCLUDED_HOSTNAMES = ['127.0.0.1', 'localhost', '::1'];
